import axios from "../api/config";
import { CustomerData } from "../components/utils/customers/CustomerData";

const error = async (err) => {
  if (err.response) {
    const message = err.response?.data.message?.toLowerCase();
    if (
      message.includes("invalid token") ||
      message.includes("expired") ||
      message.includes("not logged in")
    ) {
      CustomerData.clearData();
      window.location.href = "/";
    }
  }
  return err.response;
};

const headers = () => {
  const token = CustomerData.getToken();

  return {
    headers: {
      authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
};

const get = async (endpoint) => {
  return await axios
    .get(endpoint)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return error(err);
    });
};

const getFile = async (endpoint,data) => {
  const request = {...data, ...headers()};
  return await axios
    .get(endpoint, request);
};

const post = async (endpoint, data) => {
  return await axios
    .post(endpoint, data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return error(err);
    });
};

const put = async (endpoint, data) => {
  return await axios
    .put(endpoint, data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return error(err);
    });
};

const deleteRequest = async (endpoint, data) => {
  const token = CustomerData.getToken();
  return await axios
    .delete(endpoint, { data }, headers())
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return error(err);
    });
};

const postWithToken = async (endpoint, data) => {
  const token = CustomerData.getToken();

  return await axios
    .post(endpoint, data, headers())
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return error(err);
    });
};

const deleteWithToken = async (endpoint) => {
  const token = CustomerData.getToken();

  return await axios
    .delete(endpoint, headers())
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return error(err);
    });
};

const getWithToken = async (endpoint) => {
  const token = CustomerData.getToken();

  return await axios
    .get(endpoint, headers())
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return error(err);
    });
};

const putWithToken = async (endpoint, data) => {
  const token = CustomerData.getToken();

  return await axios
    .put(endpoint, data, headers())
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return error(err);
    });
};

const API = {
  get,
  post,
  postWithToken,
  getWithToken,
  deleteRequest,
  deleteWithToken,
  putWithToken,
  put,
  getFile,
};

export default API;
